import { useContext, useState } from 'react';
import EarlyAccessContext from '../context/EarlyAccessContext';
import './EarlyAccessModal.css';

const EarlyAccessModal = () => {
  const { isOpen, setIsOpen } = useContext(EarlyAccessContext);
  const [email, setEmail] = useState('');
  const [consent, setConsent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    try {
      const response = await fetch('/.netlify/functions/waitlist-signup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, consent }),
      });

      const data = await response.json();

      if (data.success) {
        setIsSuccess(true);
        setMessage(data.message || 'Thank you! Please check your email to confirm your signup.');
        setEmail('');
        setConsent(false);
        setTimeout(() => {
          setIsOpen(false);
          setIsSuccess(false);
          setMessage('');
        }, 3000);
      } else {
        setMessage(data.message || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      setMessage('Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={() => setIsOpen(false)}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal__close" onClick={() => setIsOpen(false)}>
          ×
        </button>

        <div className="modal__content">
          <h2>Join Founding Families</h2>
          <p>Early access opens soon. Be the first to know when we launch.</p>

          {isSuccess ? (
            <div className="modal__success">
              <p>✓ You're on the list!</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="modal__form">
              <input
                type="email"
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isLoading}
                className="modal__input"
              />
              
              <label className="modal__checkbox-label">
                <input
                  type="checkbox"
                  checked={consent}
                  onChange={(e) => setConsent(e.target.checked)}
                  required
                  disabled={isLoading}
                  className="modal__checkbox"
                />
                <span>
                  I agree to receive updates about Sprout Academy and can unsubscribe at any time.
                </span>
              </label>

              <button
                type="submit"
                disabled={isLoading || !consent}
                className="btn btn--primary modal__button"
              >
                {isLoading ? 'Joining...' : 'Join the list'}
              </button>
              {message && (
                <p className={`modal__message ${isSuccess ? 'modal__message--success' : 'modal__message--error'}`}>
                  {message}
                </p>
              )}
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default EarlyAccessModal;
